import React from 'react';
import Mention from '../ui/Mention';
import { useIntl } from 'react-intl-next';
import { messages } from '../messages';
var MentionAssistiveTextComponent = /*#__PURE__*/React.memo(function (_ref) {
  var mentionedName = _ref.mentionedName;
  var intl = useIntl();
  return /*#__PURE__*/React.createElement("span", {
    className: 'assistive'
  }, "".concat(intl.formatMessage(messages.mentionsNodeLabel), " ").concat(mentionedName));
});
export var MentionNodeView = function MentionNodeView(props) {
  var providerFactory = props.providerFactory;
  var _props$node$attrs = props.node.attrs,
    id = _props$node$attrs.id,
    text = _props$node$attrs.text,
    accessLevel = _props$node$attrs.accessLevel;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(MentionAssistiveTextComponent, {
    mentionedName: text
  }), /*#__PURE__*/React.createElement("span", {
    "aria-hidden": "true"
  }, /*#__PURE__*/React.createElement(Mention, {
    id: id,
    text: text,
    accessLevel: accessLevel,
    providers: providerFactory
  })));
};